import { render } from "./RegistryControlPage.vue?vue&type=template&id=637e0246&scoped=true"
import script from "./RegistryControlPage.vue?vue&type=script&lang=js"
export * from "./RegistryControlPage.vue?vue&type=script&lang=js"

import "./RegistryControlPage.vue?vue&type=style&index=0&id=637e0246&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637e0246"]])

export default __exports__